module.exports = __webpack_public_path__ + "img/box-open.d352be93.svg";